import { render } from "./Upload.vue?vue&type=template&id=4d2ce9db"
import script from "./Upload.vue?vue&type=script&lang=ts"
export * from "./Upload.vue?vue&type=script&lang=ts"
script.render = render

export default script